import type React from 'react';
import { useFormContext } from 'react-hook-form';

import { IconButton } from '@mui/material';

type Props = {
	id: number;
};

export const Periodicity: React.FC<Props> = ({ id }) => {
	const { watch, setValue } = useFormContext();

	const programVideos = watch('exercises');
	const excluded = watch('excluded_videos_period');

	const isChecked = (day: number, id: number, excluded: number[][]) => {
		return !!!excluded[day]?.find((el) => el === id);
	};

	const checkVideo = (day: number, id: number, excluded: number[][], videos: number[]) => {
		const allVideos = [...videos];
		let currentExcluded = excluded[day];
		const finalExcluded = [...excluded];

		if (currentExcluded.includes(id)) {
			currentExcluded = currentExcluded.filter((video) => video !== id);
			finalExcluded[day] = [...currentExcluded];
		} else {
			const filter = allVideos.filter(
				(videoId: number) => videoId === id || currentExcluded.includes(videoId)
			);
			finalExcluded[day] = [...filter];
		}
		setValue('excluded_videos_period', finalExcluded, { shouldDirty: true });
		return;
	};

	const days = [0, 1, 2, 3, 4, 5, 6];

	const buttonStyle = {
		width: '26px',
		height: '26px',
		padding: 0,
		backgroundColor: '#fff',
		'&:hover': {
			backgroundColor: '#4198c5',
			color: '#fff',
		},
	};

	const uncheckStyle = {
		width: '26px',
		height: '26px',
		backgroundColor: 'transparent',
		border: '1px solid #fff',
		'&:hover': {
			border: '1px solid #4198c5',
		},
	};

	return (
		<div
			style={{
				display: 'flex',
				justifyContent: 'space-between',
				gap: '8px',
				paddingBottom: '10px',
			}}
		>
			{days.map((day) => (
				<IconButton
					key={day}
					sx={isChecked(day, id, excluded) ? { ...buttonStyle } : { ...uncheckStyle }}
					onClick={() => checkVideo(day, id, excluded, programVideos)}
				>
					{isChecked(day, id, excluded) && <span style={{ fontSize: 12 }}>{day + 1}</span>}
				</IconButton>
			))}
		</div>
	);
};
